import { Route, Routes } from 'react-router-dom'
import Home from './components/Home'
import About from './components/About'
import Contact from './components/Contact'
import { ToastContainer } from "react-toastify";
import './App.scss'

function App() {
  return (
    <div className="page">
      <span className="tags tag-html">&lt;html&gt;</span>
      <br />
      <span className="tags tag-body">&lt;body&gt;</span>


      <div className='contenu'>
        <Home/>
        <About/>
        <Contact/>
      </div>
      <span className="tags tag-body">&lt;/body&gt;</span>
      <br />
      <span className="tags tag-html">&lt;/html&gt;</span>
      <ToastContainer />
    </div>

  )
}

export default App
